import React from 'react';
import Card from '../../ui/Card';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
const CompositeTrendChart: React.FC = () => {
  const data = [{
    month: 'Jan',
    revenue: 720,
    margin: 17.1,
    costIndex: 105
  }, {
    month: 'Feb',
    revenue: 745,
    margin: 17.3,
    costIndex: 106
  }, {
    month: 'Mar',
    revenue: 768,
    margin: 17.6,
    costIndex: 107
  }, {
    month: 'Apr',
    revenue: 752,
    margin: 17.4,
    costIndex: 108
  }, {
    month: 'May',
    revenue: 785,
    margin: 17.8,
    costIndex: 109
  }, {
    month: 'Jun',
    revenue: 802,
    margin: 18.0,
    costIndex: 110
  }, {
    month: 'Jul',
    revenue: 795,
    margin: 17.9,
    costIndex: 111
  }, {
    month: 'Aug',
    revenue: 820,
    margin: 18.2,
    costIndex: 112
  }, {
    month: 'Sep',
    revenue: 812,
    margin: 18.1,
    costIndex: 111
  }, {
    month: 'Oct',
    revenue: 835,
    margin: 18.3,
    costIndex: 110
  }, {
    month: 'Nov',
    revenue: 848,
    margin: 18.4,
    costIndex: 109
  }, {
    month: 'Dec',
    revenue: 868,
    margin: 18.3,
    costIndex: 108
  }];
  return <Card className="p-6 bg-gradient-to-br from-blue-50 to-white" data-id="element-2760">
      <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-2761">
        Composite Business Trend
      </h3>
      <p className="text-sm text-gray-600 mb-4" data-id="element-2762">
        Revenue (₹ Cr), EBITDA Margin (%), Cost Index (Base 100)
      </p>
      <ResponsiveContainer width="100%" height={300} data-id="element-2763">
        <LineChart data={data} data-id="element-2764">
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" data-id="element-2765" />
          <XAxis dataKey="month" tick={{
          fontSize: 12
        }} data-id="element-2766" />
          <YAxis yAxisId="left" tick={{
          fontSize: 12
        }} data-id="element-2767" />
          <YAxis yAxisId="right" orientation="right" tick={{
          fontSize: 12
        }} data-id="element-2768" />
          <Tooltip contentStyle={{
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '8px',
          boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
        }} data-id="element-2769" />
          <Legend data-id="element-2770" />
          <Line yAxisId="left" type="monotone" dataKey="revenue" stroke="#3b82f6" strokeWidth={3} name="Revenue (₹ Cr)" dot={{
          r: 4
        }} data-id="element-2771" />
          <Line yAxisId="right" type="monotone" dataKey="margin" stroke="#10b981" strokeWidth={3} name="EBITDA Margin %" dot={{
          r: 4
        }} data-id="element-2772" />
          <Line yAxisId="right" type="monotone" dataKey="costIndex" stroke="#ef4444" strokeWidth={2} strokeDasharray="5 5" name="Cost Index" dot={{
          r: 3
        }} data-id="element-2773" />
        </LineChart>
      </ResponsiveContainer>
    </Card>;
};
export default CompositeTrendChart;